import React from 'react';

import {ITableReportDataRequestParams} from 'store/slices/table-report-slice/table-report-slice-types';

import {EActionType, IReportConfigurationAction} from '../model/types';
import {RunButtonAction} from '../ui/actions/run-button-action';
import {UploadFileAction} from '../ui/actions/upload-file-action';

interface IDynamicActionResolver {
  action: IReportConfigurationAction;
  selectedTableRows: number[];
  docId: string | null;
  templateCode: string | undefined;
  isAllRowsSelected: boolean;
  pageRequestDto?: Omit<ITableReportDataRequestParams, 'templateCode' | 'docId' | 'lookupType'>;
  handleRefreshReportPage?: () => void;
}

export const dynamicActionResolver = ({
    action,
    selectedTableRows,
    docId,
    templateCode,
    isAllRowsSelected,
    pageRequestDto,
    handleRefreshReportPage,
}: IDynamicActionResolver) => {
    switch (action?.actionType) {
    case EActionType.BUTTON: {
        return (
            <RunButtonAction
                action={action}
                selectedTableRows={selectedTableRows}
                docId={docId}
                templateCode={templateCode}
                isAllRowsSelected={isAllRowsSelected}
                pageRequestDto={pageRequestDto}
                handleRefreshReportPage={handleRefreshReportPage}
            />
        );
    }
    case EActionType.UPLOAD_FILE: {
        return (
            <UploadFileAction
                action={action}
                docId={docId}
                templateCode={templateCode}
                handleRefreshReportPage={handleRefreshReportPage}
            />
        );
    }
    default: {
        return null;
    }
    }
};
